/*
 * @Author: Q in
 * @Date: 2025-12-22 11:31:04
 * @LastEditors: Q in 
 * @LastEditTime: 2026-04-16 14:41:01
 * @FilePath: /bf_web/src/utils/theme.js
 * @Description: 自定义主题样式
 */
export const themes = {
	// 原始主题
	theme1: {
		'--el-color-primary1': '#3a8ee6' /* 主色 */,
		'--el-color-primary2': '#409eff' /* 较深的蓝色 */,
		'--el-color-primary3': '#66b1ff' /* 中等蓝色 */,
		'--el-color-primary4': '#8cc5ff' /* 浅绿色 */,
		'--el-color-primary5': '#a0cfff' /* 更浅的蓝色 */,
		'--el-color-primary6': '#b3d8ff' /* 极浅绿色 */,
		'--el-color-primary7': '#c6e2ff' /* 非常淡的蓝色 */,
		'--el-color-primary8': '#d9ecff' /* 近乎白色的蓝色调 */,
		'--el-color-primary9': '#ecf5ff' /* 接近白色的淡蓝色 */,

		'--el-color-success1': '#5daf34' /* 主色 */,
		'--el-color-success2': '#67c23a' /* 较深的绿色 */,
		'--el-color-success3': '#85ce61' /* 中等绿色 */,
		'--el-color-success4': '#a4da89' /* 浅绿色 */,
		'--el-color-success5': '#b3e19d' /* 更浅的绿色 */,
		'--el-color-success6': '#c2e7b0' /* 极浅绿色 */,
		'--el-color-success7': '#e1f3d8' /* 非常淡的绿色 */,
		'--el-color-success8': '#f0f9eb' /* 近乎白色的绿色调 */
	},

	// 橙红色主题
	theme2: {
		'--el-color-primary1': '#ff5926' /* 主色：鲜艳橙色 */,
		'--el-color-primary2': '#ff6f38' /* 略深的橙色 */,
		'--el-color-primary3': '#ff8750' /* 中等橙色 */,
		'--el-color-primary4': '#ff9f6a' /* 浅橙色 */,
		'--el-color-primary5': '#ffb983' /* 更浅的橙色 */,
		'--el-color-primary6': '#ffc9a5' /* 极浅的橙色 */,
		'--el-color-primary7': '#ffdab0' /* 非常淡的橙色 */,
		'--el-color-primary8': '#ffe8cc' /* 近乎白色的橙色调 */,
		'--el-color-primary9': '#fff4e0' /* 接近白色的淡橙色 */,

		'--el-color-success1': '#008858' /* 主色深绿色 */,
		'--el-color-success2': '#1e9f6b' /* 较深的绿色 */,
		'--el-color-success3': '#4bbf83' /* 中等绿色 */,
		'--el-color-success4': '#7fcd99' /* 浅绿色 */,
		'--el-color-success5': '#a5e3b2' /* 更浅的绿色 */,
		'--el-color-success6': '#c0e8c8' /* 极浅绿色 */,
		'--el-color-success7': '#d7f4db' /* 非常淡的绿色 */,
		'--el-color-success8': '#e9f9eb' /* 近乎白色的绿色调 */
	},

	// 紫色主题
	theme3: {
		'--el-color-primary1': '#b852dd' /* 主色 */,
		'--el-color-primary2': '#cc5bf5' /* 较深的紫色 */,
		'--el-color-primary3': '#d67cf7' /* 中等紫色 */,
		'--el-color-primary8': '#e09df9' /* 极浅的紫色 */,
		'--el-color-primary6': '#e6adfa' /* 更浅的紫色 */,
		'--el-color-primary7': '#ebbdfb' /* 非常淡的紫色 */,
		'--el-color-primary4': '#f0cefc' /* 浅绿色 */,
		'--el-color-primary9': '#f5defd' /* 接近白色的淡紫色 */,
		'--el-color-primary5': '#faeffe' /* 更浅的紫色 */,

		'--el-color-success1': '#008858' /* 主色深绿色 */,
		'--el-color-success2': '#1e9f6b' /* 较深的绿色 */,
		'--el-color-success3': '#4bbf83' /* 中等绿色 */,
		'--el-color-success4': '#7fcd99' /* 浅绿色 */,
		'--el-color-success5': '#a5e3b2' /* 更浅的绿色 */,
		'--el-color-success6': '#c0e8c8' /* 极浅绿色 */,
		'--el-color-success7': '#d7f4db' /* 非常淡的绿色 */,
		'--el-color-success8': '#e9f9eb' /* 近乎白色的绿色调 */
	}
};

// 切换主题函数
export function switchTheme(themeName) {
	const theme = themes[themeName];
	if (!theme) {
		console.error(`主题 ${themeName} 不存在`);
		return;
	}

	const root = document.documentElement;
	Object.keys(theme).forEach((key) => {
		root.style.setProperty(key, theme[key]);
	});
}

// 初始化主题
export function initTheme(themeName) {
	const savedTheme = themeName;
	switchTheme(savedTheme);
	return savedTheme;
}
